const apiURL = process.env.REACT_APP_API_URL ?? "";

const createInput = (name: string, value: string) => {
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = name;
    input.value = value;
    return input;
};

export const download = (
    url: string,
    accessToken: string | undefined,
    requestBody?: string,
) => {
    const formId = "downloader";
    const existingForm = document.getElementById(formId);
    if (existingForm) existingForm.remove();

    const form = document.createElement("form");
    form.id = formId;
    form.hidden = true;
    form.method = "POST";
    form.action = `${apiURL}${url}`;
    document.body.appendChild(form);

    form.appendChild(createInput("auth", accessToken ?? ""));
    if (requestBody) form.appendChild(createInput("body", requestBody));
    form.submit();
};

export const downloadInBrowser = (content: string, fileName: string) => {
    const blob = new Blob([content], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", fileName);
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
